<template>
  <login-panel
    back-route-name="insert-user-data"
    class="retrieve-options"
    xs
  >
    <div class="retrieve-options__container">
      <div class="retrieve-options__content">
        <h3 class="retrieve-options__text">
          {{ $t('login.retrieve-options-text') }}
        </h3>
        <b-button
          class="retrieve-btn s-btn-no-custom"
          @click="emailRecoverSelect"
        >
          <img
            src="/static/imgs/send-email-green.png"
            class="retrieve-btn__icon"
            alt="send mail icon"
          >
          <span class="retrieve-btn__text">
            {{ $t('login.retrieve-option-link') }}
          </span>
        </b-button>
        <b-button
          class="retrieve-btn s-btn-no-custom"
          @click="answerSecretQuestionSelect"
        >
          <img
            src="/static/imgs/question-circle-green.png"
            class="retrieve-btn__icon"
            alt="send mail icon"
          >
          <span class="retrieve-btn__text">
            {{ $t('login.retrieve-option-secret-answer') }}
          </span>
        </b-button>
      </div>
    </div>
  </login-panel>
</template>

<script>
import { mapGetters } from 'vuex';
import LoginPanel from '@/components/LoginPanel';
import PasswordRecoverService from '@/domain/services/login/passwordRecoverService';

export default {
  components: {
    LoginPanel,
  },
  computed: {
    ...mapGetters([
      'recoverData',
    ]),
  },
  created() {
    if (!this.recoverData) {
      this.$router.push({
        name: 'insert-user-data',
      });
    }
  },
  methods: {
    emailRecoverSelect() {
      PasswordRecoverService.sendEmailPassword(this.recoverData.email)
        .then(() => {
          this.$router.push({
            name: 'temporary-password-sent',
          });
        });
    },
    answerSecretQuestionSelect() {
      if (this.recoverData.secretQuestion) {
        this.$router.push({
          name: 'answer-secret-question',
        });
        return;
      }
      this.$pushAlert({
        code: 'me009',
        messageParams: {
          NomeDoUsuario: this.recoverData.username,
        },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.retrieve-btn
  display: flex
  align-items: center
  border: 1px solid $color-primary
  border-radius: 5px
  background-color: var(--color-extend-lightgreen)
  color: var(--color-black-87)
  width: 100%
  padding: 5px 10px
  height: 50px
  cursor: pointer
  margin-top: 20px
  &__text
    font-size: .85rem
    text-align: center
  &__icon
    height: auto
    flex-shrink: 0
    margin-right: 5px
    width: 30px

.retrieve-options
  &__container
    display: flex
    height: 100%
    flex: 1
    justify-content: center
  &__content
    display: flex
    flex-direction: column
    flex: 1
    margin-top: 50px
  &__text
    text-align: center
    font-weight: 600
    font-size: 1.1rem
    margin-bottom: 10px
</style>
